import React from 'react'
import BlogsHero from './section/BlogsHero.js'
import BlogList from './section/BlogList.js'



const Blogs = () => {
  return (
  <>
 <BlogsHero/>
 <BlogList/>
  </>
  )
}

export default Blogs